import React from 'react'
import PropTypes from 'prop-types'
import './style.css'
import Currency from '../../_common/Currency'
import NRTButton from '../../_common/_buttons/Button'
import DateInterval from '../../_common/DateInterval'

const NRTCourseRelease = ({ id, title, location, value, onClick, startDate, endDate, startTime, endTime }) => {
    return (
        <NRTButton onClick={() => onClick(id)} className={'nrt-course-release-button'}>
            <div className="nrt-course-release">
                <h4>{title}</h4>
                <DateInterval startDate={startDate} startTime={startTime} endDate={endDate} endTime={endTime} />
                <p>{location}</p>
                <p className={'price'}>
                    <Currency value={value} />
                </p>
            </div>
        </NRTButton>
    )
}

NRTCourseRelease.propTypes = {
    title: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    ...DateInterval.propTypes,
    onClick: PropTypes.func
}

NRTCourseRelease.defaultProps = {
}

export default NRTCourseRelease



// WEBPACK FOOTER //
// ./src/components/_courses/CourseRelease/index.js